import { useEffect, useState } from 'react'

export function useSavedState<T>(key: string, defaultValue: T, constructor?: (serialized: string) => T): [T, (value: T) => void] {
  const [state, setState] = useState(defaultValue)

  useEffect(() => {
    const savedState = localStorage.getItem(key)
    if (savedState) {
      try {
        if (constructor !== undefined && savedState !== 'null' && savedState !== 'undefined') {
          setState(constructor(JSON.parse(savedState) as string))
        }
        else {
          setState(JSON.parse(savedState))
        }
      } catch {
        setState(defaultValue)
      }
    }
  }, [])

  const updateState = (value: T) => {
    if (value === null || value === undefined) {
      localStorage.removeItem(key)
    } else {
      localStorage.setItem(key, JSON.stringify(value))
    }
    setState(value)
  }

  return [state, updateState]
}
